// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "modal-3-jtZ";
var _4 = "modal_bottom-3ctU6";
var _5 = "modal_mobileFullScreen-1yrG0";
var _6 = "modal_rounded-1mIWL";
var _7 = "extraTitle-1omNX";
var _8 = "closeIcon-3-Yiq";
var _9 = "scrollBody-3XXu-";
var _a = "title-3Vq7L";
var _b = "titleText-N178c";
var _c = "closeIcon_mobileFullScreen-2Rtht";
export { _1 as "__esModule", _2 as "mobile", _3 as "modal", _4 as "modal_bottom", _5 as "modal_mobileFullScreen", _6 as "modal_rounded", _7 as "extraTitle", _8 as "closeIcon", _9 as "scrollBody", _a as "title", _b as "titleText", _c as "closeIcon_mobileFullScreen" }
export default { "__esModule": _1, "mobile": _2, "modal": _3, "modal_bottom": _4, "modal_mobileFullScreen": _5, "modal_rounded": _6, "extraTitle": _7, "closeIcon": _8, "scrollBody": _9, "title": _a, "titleText": _b, "closeIcon_mobileFullScreen": _c }
